(function () {
  if (window.__ga4ProductPageListenerActive) return;
  window.__ga4ProductPageListenerActive = true;

  function getProductData(variantId) {
    var script = document.querySelector(
      '[data-product-data][data-variant-id="' + variantId + '"]'
    );
    if (!script) return null;
    try { return JSON.parse(script.textContent); }
    catch (e) { return null; }
  }

  function getCurrentVariantId() {
    // Cerca l'input hidden "id" nella form prodotto principale
    var input = document.querySelector(
      'form[data-type="add-to-cart-form"] input[name="id"]'
    );
    return input ? input.value : null;
  }

  function getCurrentQty() {
    // Cerca il quantity input visibile nella pagina prodotto
    var input = document.querySelector(
      '.x-quantity-selector input[type="number"], ' +
      '.x-block-buy-buttons input[type="number"]'
    );
    return input ? (parseInt(input.value, 10) || 1) : 1;
  }

  function pushEvent(eventName, variantId, quantity) {
    var d = getProductData(variantId);
    if (!d) return;
    var qty = quantity || 1;
    var gtm = window.GTMData || {};
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: eventName,
      store_country: gtm.store_country || '',
      store_language: gtm.store_language || '',
      ecommerce: {
        currency: d.currency,
        value: d.price * qty,
        items: [{
          item_name:  d.title,
          item_id:    d.sku || String(variantId),
          price:      d.price,
          item_brand: d.vendor,
          quantity:   qty,
          discount:   Math.max(0, (d.compare_at_price || d.price) - d.price)
        }]
      }
    });
  }

  // ── ADD TO CART ──────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var atcBtn = e.target.closest(
      '[id^="x-atc-button-"]:not([id*="sticky"])'
    );
    if (atcBtn && !atcBtn.closest('#main-cart-items') && !atcBtn.closest('#CartDrawer')) {
      var variantId = getCurrentVariantId();
      var qty = getCurrentQty();
      if (variantId) {
        var obs = new MutationObserver(function(mutations, observer) {
          var loadingEl = atcBtn.querySelector('[x-show="loading"]');
          if (loadingEl && loadingEl.style.display === 'none') {
            observer.disconnect();
            pushEvent('add_to_cart', variantId, qty);
          }
        });
        obs.observe(atcBtn, { attributes: true, subtree: true, attributeFilter: ['style', 'class'] });
        setTimeout(function() { obs.disconnect(); }, 3000);
      }
    }
  }, true);

})();